import styled from 'styled-components'
import { Button } from 'pcln-design-system'

const StyledMenuButton = styled(Button)`
  align-items: center;
  border: 1px solid ${props => props.theme.colors[props.borderColor]};
  display: flex;
  height: ${props => (props.isMobile ? '46' : '56')}px;
  padding: 6px;
`

export default StyledMenuButton
